<template>
  <div>
    <v-overlay
      v-model="showSuccess"
      :scrim="true"
      opacity="0.3"
      persistent
      :z-index="9998"
    >
    </v-overlay>
    <!-- Success Toast -->
    <transition name="fade-slide">
      <div v-if="showSuccess" class="success-toast" role="status" style="position: fixed; top: 30px; left: 50%; transform: translateX(-50%); z-index: 9999;">
        <img src="@/assets/mdi_success-bold.svg" alt="img" width="20" height="20" />
        <span style="font-size: 14px; font-weight: 600;">{{ SuccessMessage }}</span>
      </div>
    </transition>

    <v-container fluid>
      <!-- <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64" type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color:' + ConfigData.FontColorTitle">{{
            $t("serviceTheme")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color:' + ConfigData.FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader> -->
      <v-card class="card border" style="box-shadow: none !important;">
        <v-flex class="flex">
          <!-- Tab Header with Buttons -->
          <v-row class="tab-header-row sticky-header px-0 mb-6 border-0">
            <v-col cols="12" md="9">
              <div class="tab-buttons" style="gap: 12px;">
                <v-btn
                  :class="{ 'tab-btn--active': activeTab === 'login' }"
                  variant="outlined"
                  @click="activeTab = 'login'"
                  class="tab-btn"
                >
                  <img src="@/assets/Icons/new_looking_computer.png" alt="looking_computer" width="24" height="24" class="mr-2 tab-btn__icon">
                  Login
                </v-btn>
                <v-btn
                  :class="{ 'tab-btn--active': activeTab === 'chatPanel' }"
                  variant="outlined"
                  @click="activeTab = 'chatPanel'"
                  class="tab-btn"
                >
                  <img src="@/assets/Icons/new_panel_right.png" alt="panel_right" width="24" height="24" class="mr-2 tab-btn__icon">
                  Chat Panel
                </v-btn>
                <v-btn
                  :class="{ 'tab-btn--active': activeTab === 'header' }"
                  variant="outlined"
                  @click="activeTab = 'header'"
                  class="tab-btn"
                >
                  <img src="@/assets/Icons/new_dual_screen_header.png" alt="dual_screen_header" width="24" height="24" class="mr-2 tab-btn__icon">
                  Header
                </v-btn>
                <v-btn
                  :class="{ 'tab-btn--active': activeTab === 'title' }"
                  variant="outlined"
                  @click="activeTab = 'title'"
                  class="tab-btn"
                >
                  <img src="@/assets/Icons/new_slide_text_title.png" alt="slide_text_title" width="24" height="24" class="mr-2 tab-btn__icon">
                  Title
                </v-btn>
                <v-btn
                  :class="{ 'tab-btn--active': activeTab === 'snipped' }"
                  variant="outlined"
                  @click="activeTab = 'snipped'"
                  class="tab-btn"
                >
                  <img src="@/assets/Icons/new_message_dots.png" alt="message_dots" width="24" height="24" class="mr-2 tab-btn__icon">
                  Snipped
                </v-btn>
                <v-btn
                  :class="{ 'tab-btn--active': activeTab === 'fullstream' }"
                  variant="outlined"
                  @click="activeTab = 'fullstream'"
                  class="tab-btn"
                >
                  <v-icon class="mr-2" size="20">mdi-forum-outline</v-icon>
                  Fullstream
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" lg="1" class="d-none d-lg-flex justify-center">
                  <v-divider
                    vertical
                    thickness="2"
                    length="45"
                    style="background: #C9C9C9; opacity: 1;"
                  ></v-divider>
                </v-col>
            <v-col cols="12" md="2" class="px-0">
              <div class="action-buttons d-flex" style="gap: 12px;">
                <v-btn 
                  color="#CDD5F3"
                  id="button-setdefault-configtheme" 
                  :loading="dialog"
                  :disabled="dialog" 
                  @click="openDefaultDialog()"
                  class="default-btn"
                >
                  <img src="@/assets/Icons/new_reset_left_line.png" alt="reset_left_line" width="24" height="24">
                  <v-tooltip activator="parent" location="top">
                    Reset All
                  </v-tooltip>
                </v-btn>
                <v-btn 
                  color="success" 
                  id="button-save-configtheme" 
                  :loading="dialog" 
                  :disabled="dialog"
                  @click="save"
                  class="save-btn"
                >
                  <img src="@/assets/Icons/new_save_floppy.svg" alt="save_floppy" width="24" height="24" class="mr-2">
                  {{ $t('save') }}
                  <v-tooltip activator="parent" location="top">
                    Save Theme
                  </v-tooltip>
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <!-- Tab Content -->
          <div class="tab-content">
            <!-- Login Tab -->
            <div v-show="activeTab === 'login'">
              <v-col cols="12">
                <v-row>
                  <v-col cols="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff;">
                      <div class="d-flex align-center mb-3">
                        <img src="@/assets/Icons/new_color_paint_brush.png" alt="color_paint_brush" width="37" height="37" class="">
                        <span class="font-weight-bold" style="font-size: 23px;">Login Style</span>
                      </div>
                      <div class="style-div">
                        <v-card-title class="text-black px-0 mb-5" style="display: flex;justify-content: space-between;"><span style=" font-weight: 600;">Logo</span>
                          <v-btn id="button-setdefault-loginlogo-configtheme" color="#CDD5F3" class="reset-btn"
                            @click="setAsDefault('Loginlogo')"
                          >
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="26" height="26" />
                            <v-tooltip activator="parent" location="top">
                              Set to Default
                            </v-tooltip>
                          </v-btn>
                        </v-card-title>
                        <DragDropFile :dialog="true" :DragDrop="true" :accept="'image/*'" :reset="resetLogo"
                        @filesUploaded="onFileChange($event, 'Loginlogo')" :multiple="false" :ShowListFile="false"
                        class="UploadFile" />
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="7">
                    <div class="d-flex align-center mb-3">
                        <img src="@/assets/Icons/new_color_content_view.png" alt="color_paint_brush" width="37" height="37" class="mr-2">
                        <span class="font-weight-bold" style="font-size: 23px;">Preview</span>
                      </div>
                    <v-card style="background-color: #ffffff; height: 400px; box-shadow: rgba(0, 0, 0, 0.11) 0px 4px 22px !important; border-radius: 12px;" class="pa-8">
                      <div align="center">
                        <v-row justify="center" class="img-intersection">
                          <v-col cols="12" style="position: relative; min-height: 350px; border-radius: 16px;">
                            <LoginStyle :logo="images.Loginlogo"/>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </div>

            <!-- Chat Panel Tab -->
            <div v-show="activeTab === 'chatPanel'">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="5">
                      <v-card style="box-shadow: none !important; background-color: #ffffff;">
                        <div class="d-flex align-center mb-3">
                          <img src="@/assets/Icons/new_color_paint_brush.png" alt="color_paint_brush" width="37" height="37" class="">
                          <span class="font-weight-bold" style="font-size: 23px;">Chat Panel Style</span>
                        </div>
                        <div class="style-div" style="height: 500px !important;">
                          <v-card-title class="text-black px-0 mb-5" style="display: flex;justify-content: space-between;"><span style=" font-weight: 600;">Chat Color</span>
                            <v-btn id="button-setdefault-chatcolor-configtheme" color="#CDD5F3" class="reset-btn"
                              @click="setAsDefault('ChatColor')"
                            >
                              <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="26" height="26" />
                              <v-tooltip activator="parent" location="top">
                                Set to Default
                              </v-tooltip>
                            </v-btn>
                          </v-card-title>
                          <!-- <v-text-field id="chatbotname-field-configtheme" v-model="ConfigData.ChatbotName"
                            :color="ConfigData.chatColorTheme"
                            hide-details label="Chatbot name" variant="outlined" density="compact" style="max-width: 500px;">
                            <template v-slot:prepend>
                              <v-menu location="bottom">
                                <template v-slot:activator="{ props }">
                                  <v-btn variant="text" style=" justify-content: center;align-items: center; margin-top:-8px;"
                                    v-bind="props" :color="ConfigData.chatColorTheme" icon>
                                    <v-img v-if="ConfigData.isImgIconChat"
                                      style="height: 36px; width: 36px; border-radius: 50%;" :src="images.ChatbotIcon" />
                                    <v-icon :color="ConfigData.chatColorTheme" v-else>{{ ConfigData.ChatbotIcon }}</v-icon>
                                  </v-btn>
                                </template>
                                <v-list class="py-0">
                                  <v-list-item v-for="(item, index) in itemsIcon" :key="index" link
                                    @click="itemsIcon.length - 1 != index ? (ConfigData.ChatbotIcon = item.icon, ConfigData.isImgIconChat = false) : ''"
                                    :class="itemsIcon.length - 1 != index ? '' : 'px-0'">
                                    <v-list-item-title v-if="itemsIcon.length - 1 != index">
                                      <v-icon :color="ConfigData.chatColorTheme">{{ item.icon }}</v-icon>
                                    </v-list-item-title>
                                    <v-list-item-title v-else>
                                      <label
                                        style="display: flex; flex:column; columns: 12em; line-height: 2.5; font-size: 14px; cursor: pointer; justify-content: center;"
                                        for="img-upload">
                                        {{ item.title }} </label>
                                      <input type="file" id="img-upload" name="avatar" class="d-none" accept="image/*"
                                        @change="inputChatIcon($event)" />
                                    </v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </template>
                            <template v-slot:append>
                              <v-btn icon style="margin-top: -8px; margin-bottom: 8px;"
                                @click="setAsDefault('ChatbotIcon')">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </template>
                          </v-text-field> -->
                          <v-color-picker id="chatcolortheme-chatpanel-configtheme"
                            v-model="ConfigData.chatColorTheme" mode="hex" width="100%" hide-mode-switch
                            show-swatches :swatches="swatches">
                          </v-color-picker>
                        </div>
                      </v-card>
                    </v-col>
                    <v-col cols="7" class="d-flex" style="flex-direction: column;">
                      <div class="d-flex align-center mb-3">
                        <img src="@/assets/Icons/new_color_content_view.png" alt="color_paint_brush" width="37" height="37" class="mr-2">
                        <span class="font-weight-bold" style="font-size: 23px;">Preview</span>
                      </div>
                      <div class="d-flex flex-column pa-4 rounded-lg" style="width: 100%; flex-grow: 1; box-shadow: 0px 4px 22px rgba(0, 0, 0, 0.11) !important; border-radius: 12px !important;"
                        ref="LeftChat">
                        <div v-for="(item, index) in listMessage" v-bind:key="index" class="pa-5">
                          <div class="d-flex flex-column justify-start mb-6">
                            <div class="float-left" style="max-width: 80%;">
                              <label class="rounded-lg rounded-tr-0" style="line-break: loose;
                                padding: 12px 16px; font-size: 14px; 
                                font-weight: 400; color: #71717A; float: left;
                                border-radius: 16px !important; background-color: #64646410;
                                line-height: 22px; white-space: pre-line; width: fit-content;
                                min-height: 45px;">{{ item.messageBot }}</label>
                            </div>
                          </div>

                          <div class="d-flex justify-end mb-6">
                            <div class="float-right d-flex" style="max-width: 80%; border-radius: 16px;">
                              
                              <label class="rounded-lg rounded-tr-0" style="line-break: loose;
                                padding: 14px 20px;
                                font-size: 14px; font-weight: 400; color: white; float: right;
                                line-height: 22px; white-space: pre-line; width: fit-content; 
                                min-height: 54px;"
                                :style="'background-color:' + ConfigData.chatColorTheme + ';'"
                              >{{ item.messageUser }}</label>
                              <img src="@/assets/Icons/new_vector.png" alt="vector" width="30" height="30" class="ml-2">
                            </div>
                          </div>
                        </div>
                        <div ref="endLeft"></div>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
            </div>

            <!-- Header Tab -->
            <div v-show="activeTab === 'header'">
              <v-col cols="12">
                <v-row>
                  <v-col cols="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff;">
                      <div class="d-flex align-center mb-3">
                        <img src="@/assets/Icons/new_color_paint_brush.png" alt="color_paint_brush" width="37" height="37" class="">
                        <span class="font-weight-bold" style="font-size: 23px;">Header Style</span>
                      </div>
                      <div class="style-div" style="height: 500px !important;">
                        <v-card-title class="text-black px-0 mb-5" style="display: flex;justify-content: space-between;">
                          <span style=" font-weight: 600;">Button Color</span>
                          <v-btn id="button-setdefault-buttoncolor-configtheme" color="#CDD5F3" class="reset-btn"
                            @click="setAsDefault('ButtonColor')"
                          >
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="26" height="26" />
                            <v-tooltip activator="parent" location="top">
                              Set to Default
                            </v-tooltip>
                          </v-btn>
                        </v-card-title>
                        <v-color-picker id="navbarbtncolortheme-header-configtheme"
                          v-model="ConfigData.NavbarBtnColorTheme" mode="hex" width="100%" hide-mode-switch
                          show-swatches :swatches="swatches">
                        </v-color-picker>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="7">
                    <div class="d-flex align-center mb-3">
                      <img src="@/assets/Icons/new_color_content_view.png" alt="color_paint_brush" width="37" height="37" class="mr-2">
                      <span class="font-weight-bold" style="font-size: 23px;">Preview</span>
                    </div>
                    <v-card style="background-color: #ffffff; box-shadow: rgba(0, 0, 0, 0.11) 0px 4px 22px !important; border-radius: 12px; height: 500px;" class="pa-8">
                      <div style="border: 1px solid #e0e0e0; border-radius: 12px; height: 100%; overflow: hidden;">
                        <ServiceThemePreview :logo="images.navlogo" :buttonColor="ConfigData.NavbarBtnColorTheme" :headerColor="ConfigData.NavbarTxtColorTheme" :headerBg="images.navBG" :titleColor="ConfigData.FontColorTitle" :titleBg="images.subNavBG" />
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff;">
                      <div class="style-div" style="height: 500px !important;">
                        <v-card-title class="text-black px-0 mb-5" style="display: flex;justify-content: space-between;">
                          <span style=" font-weight: 600;">Text Color</span>
                          <v-btn id="button-setdefault-textcolor-configtheme" color="#CDD5F3" class="reset-btn"
                            @click="setAsDefault('TextColor')"
                          >
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="26" height="26" />
                            <v-tooltip activator="parent" location="top">
                              Set to Default
                            </v-tooltip>
                          </v-btn>
                        </v-card-title>
                        <v-color-picker id="navbartxtcolortheme-header-configtheme"
                          v-model="ConfigData.NavbarTxtColorTheme" mode="hex" width="100%" hide-mode-switch
                          show-swatches :swatches="swatches">
                        </v-color-picker>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="7">
                    <v-card style="background-color: #ffffff; box-shadow: rgba(0, 0, 0, 0.11) 0px 4px 22px !important; border-radius: 12px; height: 500px;" class="pa-8">
                      <div style="border: 1px solid #e0e0e0; border-radius: 12px; height: 100%; overflow: hidden;">
                        <ServiceThemePreview :logo="images.navlogo" :buttonColor="ConfigData.NavbarBtnColorTheme" :headerColor="ConfigData.NavbarTxtColorTheme" :headerBg="images.navBG" :titleColor="ConfigData.FontColorTitle" :titleBg="images.subNavBG" />
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff;">
                      <div class="style-div" style="height: 500px !important;">
                        <v-card-title class="text-black px-0 mb-5" style="display: flex;justify-content: space-between;">
                          <span style=" font-weight: 600;">Header Logo</span>
                          <v-btn id="button-setdefault-navlogo-configtheme" color="#CDD5F3" class="reset-btn"
                            @click="setAsDefault('NavLogo')"
                          >
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="26" height="26" />
                            <v-tooltip activator="parent" location="top">
                              Set to Default
                            </v-tooltip>
                          </v-btn>
                        </v-card-title>
                        <DragDropFile :dialog="true" :DragDrop="true" :accept="'image/*'" :reset="resetHeaderLogo"
                          @filesUploaded="onFileChange($event, 'NavLogo')" :multiple="false" :ShowListFile="false"
                          class="UploadFile" />
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="7">
                    <v-card style="background-color: #ffffff; box-shadow: rgba(0, 0, 0, 0.11) 0px 4px 22px !important; border-radius: 12px; height: 500px;" class="pa-8">
                      <div style="border: 1px solid #e0e0e0; border-radius: 12px; height: 100%; overflow: hidden;">
                        <ServiceThemePreview :logo="images.navlogo" :buttonColor="ConfigData.NavbarBtnColorTheme" :headerColor="ConfigData.NavbarTxtColorTheme" :headerBg="images.navBG" :titleColor="ConfigData.FontColorTitle" :titleBg="images.subNavBG" />
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff;">
                      <div class="style-div" style="height: 500px !important;">
                        <v-card-title class="text-black px-0 mb-5" style="display: flex;justify-content: space-between;">
                          <span style=" font-weight: 600;">Header Background</span>
                          <v-btn id="button-setdefault-navbg-configtheme" color="#CDD5F3" class="reset-btn"
                            @click="setAsDefault('NavBG')"
                          >
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="26" height="26" />
                            <v-tooltip activator="parent" location="top">
                              Set to Default
                            </v-tooltip>
                          </v-btn>
                        </v-card-title>
                        <DragDropFile :dialog="true" :DragDrop="true" :accept="'image/*'" :reset="resetNavBg"
                          @filesUploaded="onFileChange($event, 'NavBG')" :multiple="false" :ShowListFile="false"
                          class="UploadFile" />
                        <!-- <v-color-picker id="navBG-header-configtheme"
                          v-model="ConfigData.navBG" mode="hex" width="100%" hide-mode-switch
                          show-swatches :swatches="swatches">
                        </v-color-picker> -->
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="7">
                    <v-card style="background-color: #ffffff; box-shadow: rgba(0, 0, 0, 0.11) 0px 4px 22px !important; border-radius: 12px; height: 500px;" class="pa-8">
                      <div style="border: 1px solid #e0e0e0; border-radius: 12px; height: 100%; overflow: hidden;">
                        <ServiceThemePreview :logo="images.navlogo" :buttonColor="ConfigData.NavbarBtnColorTheme" :headerColor="ConfigData.NavbarTxtColorTheme" :headerBg="images.navBG" :titleColor="ConfigData.FontColorTitle" :titleBg="images.subNavBG" />
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </div>

            <!-- Title Tab -->
            <div v-show="activeTab === 'title'">
              <v-col cols="12">
                <v-row>
                  <v-col cols="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff;">
                      <div class="d-flex align-center mb-3">
                        <img src="@/assets/Icons/new_color_paint_brush.png" alt="color_paint_brush" width="37" height="37" class="">
                        <span class="font-weight-bold" style="font-size: 23px;">Title Style</span>
                      </div>
                      <div class="style-div" style="height: 500px !important;">
                        <v-card-title class="text-black px-0 mb-5" style="display: flex;justify-content: space-between;">
                          <span style=" font-weight: 600;">Font Color</span>
                          <v-btn id="button-setdefault-fontcolor-configtheme" color="#CDD5F3" class="reset-btn"
                            @click="setAsDefault('FontColor')"
                          >
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="26" height="26" />
                            <v-tooltip activator="parent" location="top">
                              Set to Default
                            </v-tooltip>
                          </v-btn>
                        </v-card-title>
                        <v-color-picker id="titlebtncolortheme-header-configtheme"
                          v-model="ConfigData.FontColorTitle" mode="hex" width="100%" hide-mode-switch
                          show-swatches :swatches="swatches">
                        </v-color-picker>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="7">
                    <div class="d-flex align-center mb-3">
                      <img src="@/assets/Icons/new_color_content_view.png" alt="color_paint_brush" width="37" height="37" class="mr-2">
                      <span class="font-weight-bold" style="font-size: 23px;">Preview</span>
                    </div>
                    <v-card style="background-color: #ffffff; box-shadow: rgba(0, 0, 0, 0.11) 0px 4px 22px !important; border-radius: 12px; height: 500px;" class="pa-8">
                      <div style="border: 1px solid #e0e0e0; border-radius: 12px; height: 100%; overflow: hidden;">
                        <ServiceThemePreview :logo="images.navlogo" :buttonColor="ConfigData.NavbarBtnColorTheme" :headerColor="ConfigData.NavbarTxtColorTheme" :headerBg="images.navBG" :titleColor="ConfigData.FontColorTitle" :titleBg="images.subNavBG"/>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff;">
                      <div class="style-div" style="height: 500px !important;">
                        <v-card-title class="text-black px-0 mb-5" style="display: flex;justify-content: space-between;">
                          <span style=" font-weight: 600;">Background</span>
                          <v-btn id="button-setdefault-subbg-configtheme" color="#CDD5F3" class="reset-btn"
                            @click="setAsDefault('SubBG')"
                          >
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="26" height="26" />
                            <v-tooltip activator="parent" location="top">
                              Set to Default
                            </v-tooltip>
                          </v-btn>
                        </v-card-title>
                        <DragDropFile :dialog="true" :DragDrop="true" :accept="'image/*'" :reset="resetTitleBg"
                          @filesUploaded="onFileChange($event, 'SubBG')" :multiple="false" :ShowListFile="false"
                          class="UploadFile" />
                        <!-- <v-color-picker id="navbartxtcolortheme-header-configtheme"
                          v-model="ConfigData.NavbarTxtColorTheme" mode="hex" width="100%" hide-mode-switch
                          show-swatches :swatches="swatches">
                        </v-color-picker> -->
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="7">
                    <v-card style="background-color: #ffffff; box-shadow: rgba(0, 0, 0, 0.11) 0px 4px 22px !important; border-radius: 12px; height: 500px;" class="pa-8">
                      <div style="border: 1px solid #e0e0e0; border-radius: 12px; height: 100%; overflow: hidden;">
                        <ServiceThemePreview :logo="images.navlogo" :buttonColor="ConfigData.NavbarBtnColorTheme" :headerColor="ConfigData.NavbarTxtColorTheme" :headerBg="images.navBG" :titleColor="ConfigData.FontColorTitle" :titleBg="images.subNavBG"/>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </div>

            <!-- Snipped Tab -->
            <div v-show="activeTab === 'snipped'">
              <v-col cols="12">
                <v-row>
                  <v-col cols="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff;">
                      <div class="d-flex align-center mb-3">
                        <img src="@/assets/Icons/new_color_paint_brush.png" alt="color_paint_brush" width="37" height="37" class="">
                        <span class="font-weight-bold" style="font-size: 23px;">Snipped Style</span>
                      </div>
                      <div class="style-div" style="height: 500px !important;">
                        <v-card-title class="text-black px-0 mb-5" style="display: flex;justify-content: space-between;">
                          <span style=" font-weight: 600;">Logo</span>
                          <v-btn id="button-setdefault-snippedlogo-configtheme" color="#CDD5F3" class="reset-btn"
                            @click="setAsDefault('Snippedlogo')"
                          >
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="26" height="26" />
                            <v-tooltip activator="parent" location="top">
                              Set to Default
                            </v-tooltip>
                          </v-btn>
                        </v-card-title>
                        <DragDropFile :dialog="true" :DragDrop="true" :accept="'image/*'" :reset="resetSnippedLogo"
                          @filesUploaded="onFileChange($event, 'Snippedlogo')" :multiple="false" :ShowListFile="false"
                          class="UploadFile" />
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="7">
                    <div class="d-flex align-center mb-3">
                      <img src="@/assets/Icons/new_color_content_view.png" alt="color_paint_brush" width="37" height="37" class="mr-2">
                      <span class="font-weight-bold" style="font-size: 23px;">Preview</span>
                    </div>
                    <v-card class="dialog_div">
                      <SnippedPreview :snippedlogo="images.snippedlogo" :bgColor="ConfigData.snippedColorThemeChat" />
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff;">
                      <div class="style-div" style="height: 500px !important;">
                        <v-card-title class="text-black px-0 mb-5" style="display: flex;justify-content: space-between;">
                          <span style=" font-weight: 600;">Chat Color</span>
                          <v-btn id="button-setdefault-snipped-configtheme" color="#CDD5F3" class="reset-btn"
                            @click="setAsDefault('SnippedColor')"
                          >
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="26" height="26" />
                            <v-tooltip activator="parent" location="top">
                              Set to Default
                            </v-tooltip>
                          </v-btn>
                        </v-card-title>
                        <v-color-picker id="snippedcolortheme-snipped-configtheme"
                          v-model="ConfigData.snippedColorThemeChat" mode="hex" width="100%" hide-mode-switch
                          show-swatches :swatches="swatches">
                        </v-color-picker>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="7">
                    <v-card class="dialog_div">
                      <SnippedPreview :snippedlogo="images.snippedlogo" :bgColor="ConfigData.snippedColorThemeChat" />
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </div>

            <!-- Fullstream Tab -->
            <div v-show="activeTab === 'fullstream'">
              <v-col cols="12">
                <v-row class="mb-6">
                  <v-col cols="12" md="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff;">
                      <div class="d-flex align-center mb-3">
                        <img src="@/assets/Icons/new_color_paint_brush.png" alt="color_paint_brush" width="37" height="37">
                        <span class="font-weight-bold" style="font-size: 23px;">Fullstream Text</span>
                      </div>
                      <div class="style-div fullstream-style-div">
                        <v-card-title class="text-black px-0 mb-5" style="display: flex;justify-content: space-between;">
                          <span style="font-weight: 600;">Preview Text</span>
                          <v-btn color="#CDD5F3" class="reset-btn" @click="resetFullstreamPreview">
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="26" height="26" />
                            <v-tooltip activator="parent" location="top">
                              Reset Fullstream Defaults
                            </v-tooltip>
                          </v-btn>
                        </v-card-title>

                        <div class="fullstream-control-group">
                          <label class="fullstream-control-label">Welcome title</label>
                          <v-text-field
                            v-model="fullstreamPreview.welcomeTitle"
                            variant="outlined"
                            density="comfortable"
                            maxlength="30"
                            counter
                            hide-details="auto"
                            bg-color="white"
                          ></v-text-field>
                        </div>

                        <div class="fullstream-control-group">
                          <label class="fullstream-control-label">Welcome subtitle</label>
                          <v-textarea
                            v-model="fullstreamPreview.welcomeSubtitle"
                            variant="outlined"
                            density="comfortable"
                            rows="3"
                            auto-grow
                            maxlength="80"
                            counter
                            hide-details="auto"
                            bg-color="white"
                          ></v-textarea>
                        </div>

                        <div class="fullstream-control-group mb-0">
                          <label class="fullstream-control-label">Disclaimer</label>
                          <v-textarea
                            v-model="fullstreamPreview.disclaimerText"
                            variant="outlined"
                            density="comfortable"
                            rows="4"
                            auto-grow
                            maxlength="60"
                            counter
                            hide-details="auto"
                            bg-color="white"
                          ></v-textarea>
                        </div>
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="7">
                    <div class="d-flex align-center mb-3">
                      <img src="@/assets/Icons/new_color_content_view.png" alt="color_content_view" width="37" height="37" class="mr-2">
                      <span class="font-weight-bold" style="font-size: 23px;">Text Preview</span>
                    </div>
                    <v-card class="fullstream-preview-card fullstream-section-preview pa-4 pa-md-6">
                      <div class="fullstream-text-preview-card">
                        <div class="fullstream-text-preview-content">
                          <h2 class="fullstream-preview-title">{{ fullstreamPreview.welcomeTitle }}</h2>
                          <p class="fullstream-preview-subtitle">{{ fullstreamPreview.welcomeSubtitle }}</p>
                        </div>

                        <div class="fullstream-text-preview-footer">
                          <div class="fullstream-chat-preview-composer fullstream-chat-preview-composer--text-preview">
                            <span class="fullstream-chat-preview-placeholder">Ask anything...</span>
                            <div class="fullstream-chat-preview-actions">
                              <span class="fullstream-preview-counter">0 / 4000</span>
                              <div class="fullstream-chat-preview-send" :style="{ backgroundColor: ConfigData.FullstreamChatColorTheme }">
                                <v-icon size="16" color="white">mdi-arrow-up</v-icon>
                              </div>
                            </div>
                          </div>

                          <div class="fullstream-preview-disclaimer-box fullstream-preview-disclaimer-box--below-chat">
                            {{ fullstreamPreview.disclaimerText }}
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row class="mb-3 align-center">
                  <v-col cols="12" md="5">
                    <div class="d-flex align-center mb-3 mb-md-0">
                      <img src="@/assets/Icons/new_color_paint_brush.png" alt="color_paint_brush" width="37" height="37">
                      <span class="font-weight-bold" style="font-size: 23px;">Fullstream Header</span>
                    </div>
                  </v-col>

                  <v-col cols="12" md="7">
                    <div class="d-flex align-center">
                      <img src="@/assets/Icons/new_color_content_view.png" alt="color_content_view" width="37" height="37" class="mr-2">
                      <span class="font-weight-bold" style="font-size: 23px;">Header Preview</span>
                    </div>
                  </v-col>
                </v-row>

                <v-row class="mb-6">
                  <v-col cols="12" md="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff;">
                      <div class="style-div fullstream-style-div fullstream-style-div--compact fullstream-style-div--single">
                        <div class="fullstream-control-panel">
                          <div class="fullstream-control-header">
                            <label class="fullstream-control-label mb-0">Header background</label>
                            <v-btn color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('FullstreamButtonColor')">
                              <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                              <v-tooltip activator="parent" location="top">
                                Reset Header Background
                              </v-tooltip>
                            </v-btn>
                          </div>
                          <v-color-picker
                            id="navbarbtncolortheme-fullstream-configtheme"
                            v-model="ConfigData.FullstreamNavbarBtnColorTheme"
                            mode="hex"
                            width="100%"
                            hide-mode-switch
                            show-swatches
                            :swatches="swatches"
                          ></v-color-picker>
                        </div>
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="7">
                    <v-card class="fullstream-preview-card fullstream-section-preview pa-4 pa-md-6">
                      <div class="fullstream-header-preview-shell fullstream-header-preview-shell--compact">
                        <span class="fullstream-header-preview-label">Header background</span>
                        <div
                          class="fullstream-header-preview-bar"
                          :style="fullstreamHeaderPreviewBarStyle"
                        >
                          <span class="fullstream-header-preview-spacer"></span>
                          <div class="fullstream-header-preview-content">
                            <span class="fullstream-header-preview-chip" :style="fullstreamHeaderPreviewChipStyle">
                              Model {{ ConfigData.ChatbotName || 'Chatbot' }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row class="mb-6">
                  <v-col cols="12" md="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff;">
                      <div class="style-div fullstream-style-div fullstream-style-div--compact fullstream-style-div--single">
                        <div class="fullstream-control-panel">
                          <div class="fullstream-control-header">
                            <label class="fullstream-control-label mb-0">Header text</label>
                            <v-btn color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('FullstreamTextColor')">
                              <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                              <v-tooltip activator="parent" location="top">
                                Reset Header Text
                              </v-tooltip>
                            </v-btn>
                          </div>
                          <v-color-picker
                            id="navbartxtcolortheme-fullstream-configtheme"
                            v-model="ConfigData.FullstreamNavbarTxtColorTheme"
                            mode="hex"
                            width="100%"
                            hide-mode-switch
                            show-swatches
                            :swatches="swatches"
                          ></v-color-picker>
                        </div>
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="7">
                    <v-card class="fullstream-preview-card fullstream-section-preview pa-4 pa-md-6">
                      <div class="fullstream-header-preview-shell fullstream-header-preview-shell--compact">
                        <span class="fullstream-header-preview-label">Header text</span>
                        <div class="fullstream-header-preview-bar" :style="fullstreamHeaderPreviewBarStyle">
                          <span class="fullstream-header-preview-spacer"></span>
                          <div class="fullstream-header-preview-content">
                            <span class="fullstream-header-preview-chip" :style="fullstreamHeaderPreviewChipStyle">
                              Model {{ ConfigData.ChatbotName || 'Chatbot' }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff;">
                      <div class="d-flex align-center mb-3">
                        <img src="@/assets/Icons/new_color_paint_brush.png" alt="color_paint_brush" width="37" height="37">
                        <span class="font-weight-bold" style="font-size: 23px;">Fullstream Chat</span>
                      </div>
                      <div class="style-div fullstream-style-div fullstream-style-div--compact">
                        <div class="fullstream-control-header">
                          <label class="fullstream-control-label mb-0">Chat accent</label>
                          <v-btn color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('FullstreamChatColor')">
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                            <v-tooltip activator="parent" location="top">
                              Reset Chat Accent
                            </v-tooltip>
                          </v-btn>
                        </div>
                        <v-color-picker
                          id="chatcolortheme-fullstream-configtheme"
                          v-model="ConfigData.FullstreamChatColorTheme"
                          mode="hex"
                          width="100%"
                          hide-mode-switch
                          show-swatches
                          :swatches="swatches"
                          class="mb-4"
                        ></v-color-picker>

                        <div class="chatbot-icon-selector">
                          <div class="chatbot-icon-selector__header">
                            <div class="chatbot-icon-selector__preview" :style="{ backgroundColor: `${ConfigData.FullstreamChatColorTheme}18`, color: ConfigData.FullstreamChatColorTheme }">
                              <v-img v-if="ConfigData.isImgIconChat" :src="images.ChatbotIcon" cover class="chatbot-icon-selector__image" />
                              <v-icon v-else size="24">{{ ConfigData.ChatbotIcon || 'mdi-robot-outline' }}</v-icon>
                            </div>
                            <div class="chatbot-icon-selector__text">
                              <label>Chatbot Icon</label>
                              <span>Select an icon or upload an image</span>
                            </div>
                            <div class="chatbot-icon-selector__actions">
                              <v-btn
                                id="button-setdefault-chatboticon-fullstream-configtheme"
                                color="#CDD5F3"
                                class="reset-btn fullstream-mini-reset"
                                @click="setAsDefault('FullstreamChatbotIcon')"
                              >
                                <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                                <v-tooltip activator="parent" location="top">
                                  Reset Chatbot Icon
                                </v-tooltip>
                              </v-btn>
                            </div>
                          </div>
                          <div class="chatbot-icon-selector__grid">
                            <button
                              v-for="item in selectableChatbotIcons"
                              :key="item.icon"
                              type="button"
                              class="chatbot-icon-option"
                              :class="{ 'chatbot-icon-option--active': !ConfigData.isImgIconChat && ConfigData.ChatbotIcon === item.icon }"
                              :style="{ color: ConfigData.FullstreamChatColorTheme }"
                              @click="selectChatbotIcon(item.icon)"
                            >
                              <v-icon size="22">{{ item.icon }}</v-icon>
                            </button>
                            <label class="chatbot-icon-option chatbot-icon-option--upload" for="img-upload" :style="{ color: ConfigData.FullstreamChatColorTheme }">
                              <v-icon size="22">mdi-image-plus-outline</v-icon>
                              <input type="file" id="img-upload" name="avatar" class="d-none" accept="image/*" @change="inputChatIcon($event)" />
                            </label>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="7">
                    <div class="d-flex align-center mb-3">
                      <img src="@/assets/Icons/new_color_content_view.png" alt="color_content_view" width="37" height="37" class="mr-2">
                      <span class="font-weight-bold" style="font-size: 23px;">Chat Preview</span>
                    </div>
                    <v-card class="fullstream-preview-card fullstream-section-preview pa-4 pa-md-6">
                      <div class="fullstream-chat-preview-shell">
                        <div class="fullstream-chat-preview-thread">
                          <div class="fullstream-chat-preview-row">
                            <div
                              class="fullstream-chat-preview-avatar"
                              :style="{ backgroundColor: `${ConfigData.FullstreamChatColorTheme}18`, color: ConfigData.FullstreamChatColorTheme }"
                            >
                              <v-img v-if="ConfigData.isImgIconChat" :src="images.ChatbotIcon" cover class="fullstream-chat-preview-avatar-image" />
                              <v-icon v-else size="18">{{ ConfigData.ChatbotIcon || 'mdi-robot-outline' }}</v-icon>
                            </div>
                            <div class="fullstream-chat-preview-bubble fullstream-chat-preview-bubble--bot">
                              Ready to assist with product questions and support.
                            </div>
                          </div>

                          <div class="fullstream-chat-preview-row fullstream-chat-preview-row--user">
                            <div
                              class="fullstream-chat-preview-bubble fullstream-chat-preview-bubble--user"
                              :style="{ backgroundColor: ConfigData.FullstreamChatColorTheme }"
                            >
                              Show me the new Fullstream greeting.
                            </div>
                          </div>
                        </div>

                        <div class="fullstream-chat-preview-composer">
                          <span class="fullstream-chat-preview-placeholder">Ask anything...</span>
                          <div class="fullstream-chat-preview-actions">
                            <span class="fullstream-preview-counter">0 / 4000</span>
                            <div class="fullstream-chat-preview-send" :style="{ backgroundColor: ConfigData.FullstreamChatColorTheme }">
                              <v-icon size="16" color="white">mdi-arrow-up</v-icon>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </div>
          </div>
        </v-flex>
      </v-card>
      <v-overlay :value="dialog">
        <v-dialog v-model="dialog" persistent width="300">
          <v-card color="#1976D2" dark>
            <v-card-text class="white--text">
              Loading Please Wait...
              <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-overlay>

      <!-- default dialog -->
      <v-dialog v-model="showDefaultDialog" max-width="570">
        <v-card class="dialog-card">
          <v-card-title class="card-dialog-title py-4 px-5" style="background: linear-gradient(100deg, #E7EBFF 0%, #FFFFFF 100%);">
            <span class="font-weight-bold" style="color: #001763 !important;">Confirm To Set Default</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-6 pb-4 px-4 body-text" style="font-weight: 600">
            Do you want to confirm to set the default?
          </v-card-text>
          <hr style="border: none; border-top: 1px solid #c9c9c9;" />
          <v-card-actions class="px-6 pb-3 pt-3 pl-8 justify-end" style="gap: 12px;">
            <button type="button" class="cancel-btn" @click="closeDefaultDialog" :disabled="deleting">{{ $t("cancel") }}</button>
            <v-btn class="delete-confirm-btn" :loading="deleting" @click="setDefault(item)">
              <p style="color: #ffffff; font-weight: 500;">{{ $t("confirm") }}</p>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- warning dialog -->
      <v-dialog v-model="showWarningDialog" max-width="570">
        <v-card class="dialog-card">
          <v-card-title class="card-dialog-title py-4 px-5" style="background: linear-gradient(100deg, #FFF2F2 0%, #FFFFFF 100%);">
            <span class="font-weight-bold" style="color: #C30000 !important;">{{warningTitle}}</span>
            <v-icon
              v-show="showButton"
              size="30"
              class="cursor-pointer float-end"
              @click="closeWarningDialog"
              style="color: black;"
            >
              mdi-close
            </v-icon>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-6 pb-4 px-4 body-text" style="font-weight: 500">
            {{warningMessage}}
          </v-card-text>
          <hr style="border: none; border-top: 1px solid #c9c9c9;" />
          <v-card-actions v-show="showButton" class="px-6 pb-3 pt-3 pl-8 justify-end" style="gap: 12px;">
            <button type="button" class="warning-btn" @click="closeWarningDialog" :disabled="deleting">OK</button>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
// import LogTrace from "@/api/function.js";
import DragDropFile from '@/components/DragDropFile.vue';
import LoginlogoImg from "@/assets/Group 141.png";
import navlogoImg from "@/assets/images/logo-removebg-preview@3x.png";
import navBGImg from "@/assets/images/gradient-abstract-style-wireframe-background 1.png";
import subNavBGImg from "@/assets/images/Rectangle 51.png";
import LoginStyle from "@/components/LoginStyle.vue";
import ServiceThemePreview from '@/components/ServiceThemePreview.vue';
import SnippedPreview from '@/components/SnippedPreview.vue';

const FULLSTREAM_PREVIEW_DEFAULTS = {
  welcomeTitle: 'Welcome to Chat Framework',
  welcomeSubtitle: 'How can I help you today?',
  disclaimerText: 'AI can make mistakes. Please double-check responses.',
};

const FULLSTREAM_COLOR_DEFAULTS = {
  headerBackground: '#FFFFFF',
  headerText: '#737277',
  chatAccent: '#737277',
};

export default {
  components: { DragDropFile, LoginStyle, ServiceThemePreview, SnippedPreview },
  inject: ["flagNav", "getIMG", "getStartUpImage", "configColor", "LoginLogo", "IconChat", "NavbarIcon",
    "NavbarBackGround", "SubNavbarBackGround", "ChatbotName", "ChatbotIcon", "FontColorTitle", "colorThemeChat", "NavbarBtnColorTheme", "NavbarTxtColorTheme"
  ],
  name: "ConfigTheme",
  data: () => ({
    showDefaultDialog: false,
    showWarningDialog: false,
    showSuccess: false,
    SuccessMessage: "",
    warningTitle: "",
    warningMessage: "",
    showButton: true,
    activeTab: 'login',
    resetLogo: false,
    resetHeaderLogo: false,
    resetNavBg: false,
    resetTitleBg: false,
    resetSnippedLogo: false,
    snippedlogo: navlogoImg,
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    dialog: false,
    today: null,
    images: {
      Loginlogo: LoginlogoImg,
      navlogo: navlogoImg,
      navBG: navBGImg,
      subNavBG: subNavBGImg,
      ChatbotIcon: null,
      snippedlogo: navlogoImg,
    },
    panel: 0,
    itemsIcon: [
      { icon: 'mdi-robot-outline' },
      { icon: 'mdi-face-agent' },
      { icon: 'mdi-face-man-shimmer' },
      { icon: 'mdi-face-woman-shimmer' },
      { icon: 'mdi-account-circle-outline' },
      { icon: 'mdi-creation-outline' },

      { icon: '', title: 'More' }
    ],
    ConfigData: {
      ChatbotName: "Chatbot",
      ChatbotIcon: "mdi-robot-outline",
      FontColorTitle: '#FFFFFF',
      chatColorTheme: '#737277',
      NavbarBtnColorTheme: '#FFFFFF',
      NavbarTxtColorTheme: '#2596be',
      FullstreamNavbarBtnColorTheme: FULLSTREAM_COLOR_DEFAULTS.headerBackground,
      FullstreamNavbarTxtColorTheme: FULLSTREAM_COLOR_DEFAULTS.headerText,
      FullstreamChatColorTheme: FULLSTREAM_COLOR_DEFAULTS.chatAccent,

      isImgIconChat: false,
      ChatIcon: null,
      LoginLogo: null,
      navlogo: null,
      navBG: null,
      subNavBG: null,
      snippedColorThemeChat: '#FFA41E',
      snippedlogo: null,
    },
    swatches: [
      ['#FF0000', '#AA0000'],
      ['#FF8800', '#AF5800'],
      // ['#FFFF00', '#AAAA00'],
      ['#00FF00', '#00AA00'],
      ['#00FFFF', '#00AAAA'],
      ['#0000FF', '#0000AA'],
    ],
    files: null,
    listMessage: [
      {
        messageUser: "👋 Welcome! You’re now chatting with your AI-powered assistant.",
        messageBot: "👋 Hello!",
        status_Process: "END",
      },
      {
        messageUser: "Nice to meet you too! 😊 \nHow can I help you today?",
        messageBot: "Nice to meet you!",
        status_Process: "END",
      }
    ],
    fullstreamPreview: { ...FULLSTREAM_PREVIEW_DEFAULTS },
  }),
  computed: {
    loginLogoC() {
      return this.images.Loginlogo;
    },
    iconChat() {
      return this.IconChat;
    },
    NavbarIconC() {
      return this.NavbarIcon;
    },
    NavbarBackGroundC() {
      return this.NavbarBackGround;
    },
    subNavbarBackGroundC() {
      return this.SubNavbarBackGround;
    },
    chatbotNameC() {
      return this.ChatbotName;
    },
    chatbotIconC() {
      return this.ChatbotIcon;
    },
    selectableChatbotIcons() {
      return this.itemsIcon.filter((item) => item.icon);
    },
    fontColorTitleC() {
      return this.FontColorTitle;
    },
    ColorThemeChatC() {
      return this.colorThemeChat;
    },
    navbarBtnColorTheme() {
      return this.NavbarBtnColorTheme;
    },
    navbarTxtColorTheme() {
      return this.NavbarTxtColorTheme;
    },
    fullstreamHeaderPreviewBarStyle() {
      return {
        backgroundColor: this.ConfigData.FullstreamNavbarBtnColorTheme,
        color: this.ConfigData.FullstreamNavbarTxtColorTheme,
      };
    },
    fullstreamHeaderPreviewChipStyle() {
      return {
        borderColor: this.ConfigData.FullstreamNavbarTxtColorTheme,
        color: this.ConfigData.FullstreamNavbarTxtColorTheme,
      };
    },

  },
  watch: {
    loginLogoC(newValue) {
      this.images.Loginlogo = `${newValue}`;
    },
    iconChat(newValue) {
      this.images.IconChat = `${newValue}`;
    },
    NavbarIconC(newValue) {
      this.images.NavbarIcon = `${newValue}`;
    },
    NavbarBackGroundC(newValue) {
      this.images.NavbarBackGround = `'${newValue}'`;
    },
    subNavbarBackGroundC(newValue) {
      this.images.SubNavbarBackGround = `${newValue}`;
    },
    chatbotNameC(newValue) {
      this.ConfigData.ChatbotName = `${newValue}`;
    },
    chatbotIconC(newValue) {
      this.ConfigData.ChatbotIcon = `${newValue}`;
    },
    fontColorTitleC(newValue) {
      this.ConfigData.FontColorTitle = `#${newValue}`;
    },
    ColorThemeChatC(newValue) {
      this.ConfigData.colorThemeChat = `#${newValue}`;
    },
    navbarBtnColorTheme(newValue) {
      this.ConfigData.NavbarBtnColorTheme = `#${newValue}`;
    },
    navbarTxtColorTheme(newValue) {
      this.ConfigData.NavbarTxtColorTheme = `#${newValue}`;
    },
    resetLogo(val) {
      if (val) {
        this.$nextTick(() => {
          this.resetLogo = false;
        });
      }
    },
    resetHeaderLogo(val) {
      if (val) {
        this.$nextTick(() => {
          this.resetHeaderLogo = false;
        });
      }
    },
    resetNavBg(val) {
      if (val) {
        this.$nextTick(() => {
          this.resetNavBg = false;
        });
      }
    },
    resetTitleBg(val) {
      if (val) {
        this.$nextTick(() => {
          this.resetTitleBg = false;
        });
      }
    },
    resetSnippedLogo(val) {
      if (val) {
        this.$nextTick(() => {
          this.resetSnippedLogo = false;
        });
      }
    },
  },

  mounted() {
    this.GetDate();
    this.Get();
  },
  methods: {
    openDefaultDialog() {
      this.showDefaultDialog = true;
    },
    closeDefaultDialog() {
      this.showDefaultDialog = false;
    },
    openWarningDialog(title, message, show = true, sec = 3000) {
      this.warningTitle = title;
      this.warningMessage = message;
      this.showWarningDialog = true;
      this.showButton = show;
      if(!show){
        setTimeout(() => {
          this.closeWarningDialog();
        }, sec);
      }
    },
    closeWarningDialog() {
      this.showWarningDialog = false;
      this.warningTitle = "";
      this.warningMessage = "";
      // Clear file input if exists
      const fileInput = document.getElementById('img-upload');
      if (fileInput) {
        fileInput.value = '';
      }
      
      // Clear any DragDropFile component inputs
      const dragDropInputs = document.querySelectorAll('input[type="file"]');
      dragDropInputs.forEach(input => {
        input.value = '';
      });
    },
    formatThemeColor(value, fallbackColor) {
      if (!value) {
        return fallbackColor;
      }

      const colorValue = String(value);
      return colorValue.startsWith('#') ? colorValue : `#${colorValue}`;
    },
    applyConfigThemeData(data) {
      if (!data) {
        return;
      }

      this.ConfigData.ChatbotName = data.nameChat || this.ConfigData.ChatbotName;
      this.ConfigData.ChatbotIcon = data.isImgIconChat == true ? "" : data.iconChat || this.ConfigData.ChatbotIcon;
      this.ConfigData.FontColorTitle = data.fontColorTitle ? `#${data.fontColorTitle}` : this.ConfigData.FontColorTitle;
      this.ConfigData.chatColorTheme = data.colorThemeChat ? `#${data.colorThemeChat}` : this.ConfigData.chatColorTheme;
      this.ConfigData.NavbarBtnColorTheme = data.navbarButton ? `#${data.navbarButton}` : this.ConfigData.NavbarBtnColorTheme;
      this.ConfigData.NavbarTxtColorTheme = data.navbarColorText ? `#${data.navbarColorText}` : this.ConfigData.NavbarTxtColorTheme;
      this.ConfigData.snippedColorThemeChat = data.snippedColorThemeChat ? `#${data.snippedColorThemeChat}` : this.ConfigData.snippedColorThemeChat;
      this.ConfigData.isImgIconChat = data.isImgIconChat;
    },
    applyFullstreamThemeData(data) {
      if (!data) {
        return;
      }

      this.ConfigData.FullstreamNavbarBtnColorTheme = this.formatThemeColor(data.fullstreamNavbarBtnColorTheme, data.navbarButton ? `#${data.navbarButton}` : this.ConfigData.FullstreamNavbarBtnColorTheme);
      this.ConfigData.FullstreamNavbarTxtColorTheme = this.formatThemeColor(data.fullstreamNavbarTxtColorTheme, data.navbarColorText ? `#${data.navbarColorText}` : this.ConfigData.FullstreamNavbarTxtColorTheme);
      this.ConfigData.FullstreamChatColorTheme = this.formatThemeColor(data.fullstreamChatColorTheme, data.colorThemeChat ? `#${data.colorThemeChat}` : this.ConfigData.FullstreamChatColorTheme);
      this.fullstreamPreview = {
        welcomeTitle: data.fullstreamWelcomeTitle ?? FULLSTREAM_PREVIEW_DEFAULTS.welcomeTitle,
        welcomeSubtitle: data.fullstreamWelcomeSubtitle ?? FULLSTREAM_PREVIEW_DEFAULTS.welcomeSubtitle,
        disclaimerText: data.fullstreamDisclaimerText ?? FULLSTREAM_PREVIEW_DEFAULTS.disclaimerText,
      };
    },
    applyConfigThemeImages(loginLogoC, chatIcon, navLogo, navBG, subBG, snippedLogo) {
      this.images.ChatbotIcon = chatIcon || this.images.ChatbotIcon;
      this.images.Loginlogo = loginLogoC || this.images.Loginlogo;
      this.images.navlogo = navLogo || this.images.navlogo;
      this.images.navBG = navBG || this.images.navBG;
      this.images.subNavBG = subBG || subNavBGImg;
      this.images.snippedlogo = snippedLogo || navlogoImg;
    },
    async Get() {
      let self = this;
      try {
        const [data, loginLogoC, chatIcon, navLogo, navBG, subBG, snippedLogo] = await Promise.all([
          new Promise((resolve) => { self.$call.GetConfigThem((response) => { resolve(response.data); }); }),
          self.getIMG("LoginLogo.png"),
          self.getIMG("ChatIcon.png"),
          self.getIMG("NavLogo.png"),
          self.getIMG("NavBG.png"),
          self.getIMG("SubBG.png"),
          self.getIMG("SnippedLogo.png"), 
        ]);
        self.applyConfigThemeData(data);
        self.applyFullstreamThemeData(data);
        self.applyConfigThemeImages(loginLogoC, chatIcon, navLogo, navBG, subBG, snippedLogo);
        self.dialog = false;
      } catch (error) {
        console.error("An error occurred while loading config:", error);
      }
    },
    convertUTCDateToLocalDate(date) {
      date = new Date(date);

      let timezone = date.getTimezoneOffset() * 60000;
      let newDate = new Date(date.getTime() - timezone);
      let output =
        newDate.getDate() +
        "/" +
        newDate.getMonth() +
        "/" +
        newDate.getFullYear() +
        "   " +
        newDate.getHours() +
        ":" +
        newDate.getMinutes();

      return output;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    createImage(file, name) {
      const reader = new FileReader();
      reader.onload = (e) => {
        // Convert to base64
        if (name == "Loginlogo") {
          this.images.Loginlogo = e.target.result;
        }
        else if (name == "ChatbotIcon") {
          this.images.ChatbotIcon = e.target.result;
        }
        else if (name == "NavLogo") {
          this.images.navlogo = e.target.result;
        }
        else if (name == "NavBG") {
          this.images.navBG = e.target.result;
        }
        else if (name == "SubBG") {
          this.images.subNavBG = e.target.result;
        }
        else if (name == "Snippedlogo") {
          this.images.snippedlogo = e.target.result;
        }
      };
      reader.readAsDataURL(file);
    },
    async inputChatIcon(evt) {
      let self = this;
      let file = evt.target.files;//[0]
      if (file.length > 0) {
        let data = file[0];
        const flagUpload = await self.CheckSizeIMG(data, 1024, 1024, 2);
        if (flagUpload) {
          self.ConfigData.isImgIconChat = true;
          self.onFileChange(file, 'ChatbotIcon')
        }
      } else {
        return;
      }
    },
    selectChatbotIcon(icon) {
      this.ConfigData.ChatbotIcon = icon;
      this.ConfigData.isImgIconChat = false;
    },
    async CheckSizeIMG(file, limitFile) {
      let self = this;
      const maxFileSize = limitFile * 1024 * 1024;
      // ตรวจสอบขนาดของไฟล์

      return new Promise((resolve) => {
        if (file.size > maxFileSize) {
          self.openWarningDialog(
            self.$t('warning'),
            `ขนาดไฟล์เกิน ${limitFile} MB`,
            false,
            3000
          );
          resolve(false);
          return;
        } else {
          resolve(true);
        }
      })
    },
    async onFileChange(file, name) {
    let self = this;
    let data = file[0];
    
    // Validate file format (only jpg and png)
    const fileExtension = data.name.split('.').pop().toLowerCase();
    const allowedFormats = ['jpg', 'jpeg', 'png'];
    
    if (!allowedFormats.includes(fileExtension)) {
      self.openWarningDialog(
        'Unsupported file format !',
        'Please upload an .png or .jpeg file no larger than 10 MB.',
        true
      );
      return;
    }
    
    // Validate file size (max 10MB)
    const maxFileSize = 10 * 1024 * 1024; // 10MB in bytes
    if (data.size > maxFileSize) {
      self.openWarningDialog(
        'Unsupported file format !',
        'Please upload an .png or .jpeg file no larger than 10 MB.',
        true
      );
      return;
    }
    
    let maximunWidth = 0;
    let maximunHeight = 0;
    const img = new Image();
    const objectURL = URL.createObjectURL(data);
    img.src = objectURL;
    
    if (!file) {
      return;
    }
    
    if (name == "Loginlogo") {
      maximunWidth = 1024;
      maximunHeight = 1024;
      img.onload = () => {
        if (img.width > maximunWidth || img.height > maximunHeight) {
          self.openWarningDialog(
            self.$t('warning'),
            `ขนาดรูปภาพต้องไม่เกิน ${maximunWidth}x${maximunHeight} พิกเซล`,
            false,
            3000
          );
          return;
        } else {
          self.ConfigData.LoginLogo = data;
          this.createImage(data, name);
        }
        URL.revokeObjectURL(objectURL);
      }
    }
    else if (name == "ChatbotIcon") {
      maximunWidth = 800;
      maximunHeight = 800;
      img.onload = () => {
        if (img.width > maximunWidth || img.height > maximunHeight) {
          self.openWarningDialog(
            self.$t('warning'),
            `ขนาดรูปภาพต้องไม่เกิน ${maximunWidth}x${maximunHeight} พิกเซล`,
            false,
            3000
          );
          return;
        } else {
          self.ConfigData.ChatbotIcon = data;
          this.createImage(data, name);
        }
        URL.revokeObjectURL(objectURL);
      }
    }
    else if (name == "NavLogo") {
      maximunWidth = 2560;
      maximunHeight = 1440;
      img.onload = () => {
        if (img.width > maximunWidth || img.height > maximunHeight) {
          self.openWarningDialog(
            self.$t('warning'),
            `ขนาดรูปภาพต้องไม่เกิน ${maximunWidth}x${maximunHeight} พิกเซล`,
            false,
            3000
          );
          return;
        } else {
          self.ConfigData.navlogo = data;
          this.createImage(data, name);
        }
        URL.revokeObjectURL(objectURL);
      }
    }
    else if (name == "NavBG") {
      maximunWidth = 2560;
      maximunHeight = 1440;
      img.onload = () => {
        if (img.width > maximunWidth || img.height > maximunHeight) {
          self.openWarningDialog(
            self.$t('warning'),
            `ขนาดรูปภาพต้องไม่เกิน ${maximunWidth}x${maximunHeight} พิกเซล`,
            false,
            3000
          );
          return;
        } else {
          self.ConfigData.navBG = data;
          this.createImage(data, name);
        }
        URL.revokeObjectURL(objectURL);
      }
    }
    else if (name == "SubBG") {
      maximunWidth = 2560;
      maximunHeight = 1440;
      img.onload = () => {
        if (img.width > maximunWidth || img.height > maximunHeight) {
          self.openWarningDialog(
            self.$t('warning'),
            `ขนาดรูปภาพต้องไม่เกิน ${maximunWidth}x${maximunHeight} พิกเซล`,
            false,
            3000
          );
          return;
        } else {
          self.ConfigData.subNavBG = data;
          this.createImage(data, name);
        }
        URL.revokeObjectURL(objectURL);
      }
    }
    else if (name == "Snippedlogo") {
      maximunWidth = 2560;
      maximunHeight = 1440;
      img.onload = () => {
        if (img.width > maximunWidth || img.height > maximunHeight) {
          self.openWarningDialog(
            self.$t('warning'),
            `ขนาดรูปภาพต้องไม่เกิน ${maximunWidth}x${maximunHeight} พิกเซล`,
            false,
            3000
          );
          return;
        } else {
          self.ConfigData.snippedlogo = data;
          this.createImage(data, name);
        }
        URL.revokeObjectURL(objectURL);
      }
    }
  },
    setAsDefault(txt) {
      let self = this;
      switch (txt) {
        case "Loginlogo":
          {
            self.images.Loginlogo = LoginlogoImg;
            self.ConfigData.LoginLogo = false;
            self.resetLogo = true;
            break;
          }
        case "ChatbotIcon": {
          self.ConfigData.isImgIconChat = false;
          self.ConfigData.ChatbotIcon = "mdi-robot-outline";
          self.ConfigData.chatColorTheme = "#737277";
          self.ConfigData.ChatbotName = "Chatbot";
          break;
        }
        case "FullstreamChatbotIcon": {
          self.ConfigData.isImgIconChat = false;
          self.ConfigData.ChatbotIcon = "mdi-robot-outline";
          self.ConfigData.ChatbotName = "Chatbot";
          break;
        }
        case "NavLogo": {
          self.images.navlogo = navlogoImg;
          self.ConfigData.navlogo = false;
          self.resetHeaderLogo = true;
          break;
        }
        case "NavBG": {
          self.images.navBG = navBGImg;
          self.ConfigData.navBG = false;
          self.resetNavBg = true;
          break;
        }
        case "SubBG": {
          self.images.subNavBG = subNavBGImg;
          self.ConfigData.subNavBG = false;
          self.resetTitleBg = true;
          break;
        }
        case "Snippedlogo": {
          self.images.snippedlogo = navlogoImg;
          self.ConfigData.snippedlogo = false;
          self.resetSnippedLogo = true;
          break;
        }
        case "ButtonColor": {
          self.ConfigData.NavbarBtnColorTheme = "#FFFFFF";
          break;
        }
        case "TextColor": {
          self.ConfigData.NavbarTxtColorTheme = "#737277";
          break;
        }
        case "ChatColor": {
          self.ConfigData.chatColorTheme = "#737277";
          break;
        }
        case "FullstreamButtonColor": {
          self.ConfigData.FullstreamNavbarBtnColorTheme = FULLSTREAM_COLOR_DEFAULTS.headerBackground;
          break;
        }
        case "FullstreamTextColor": {
          self.ConfigData.FullstreamNavbarTxtColorTheme = FULLSTREAM_COLOR_DEFAULTS.headerText;
          break;
        }
        case "FullstreamChatColor": {
          self.ConfigData.FullstreamChatColorTheme = FULLSTREAM_COLOR_DEFAULTS.chatAccent;
          break;
        }
        case "FontColor": {
          self.ConfigData.FontColorTitle = "#FFFFFF";
          break;
        }
        case "SnippedColor": {
          self.ConfigData.snippedColorThemeChat = "#FFA41E";
          break;
        }
        default:
          break;
      }
    },
    resetFullstreamPreview() {
      this.fullstreamPreview = { ...FULLSTREAM_PREVIEW_DEFAULTS };
      this.setAsDefault('FullstreamButtonColor');
      this.setAsDefault('FullstreamTextColor');
      this.setAsDefault('FullstreamChatColor');
    },
    setDefault() {
      let self = this;
      self.closeDefaultDialog();
      self.dialog = true;
      self.$call.SetDefault((dataResponse) => {
        self.dialog = false;
        if (dataResponse.status == 0) {
          self.SuccessMessage = " Changed Default Style !";
          self.showSuccess = true;
          clearTimeout(self._addToastTimer);
          self._addToastTimer = setTimeout(() => {
            self.showSuccess = false;
          }, 1500);
          self.GetStartUpImage;
          self.configColor;
          self.resetLogo = true;
          self.resetHeaderLogo = true;
          self.resetNavBg = true;
          self.resetTitleBg = true;
          self.resetSnippedLogo = true;
        }
        window.location.reload();
      },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    save() {
      let self = this;
      self.dialog = true;
      let isImgChat = self.ConfigData.isImgIconChat ?? false;
      let setDefault = [];
      if (self.ConfigData.LoginLogo == false) { setDefault.push(1); }
      if (self.ConfigData.navlogo == false) { setDefault.push(2); }
      if (self.ConfigData.navBG == false) { setDefault.push(3); }
      if (self.ConfigData.subNavBG == false) { setDefault.push(4); }
      if (self.ConfigData.ChatbotIcon == "mdi-robot-outline" && self.ConfigData.isImgIconChat == false) { setDefault.push(5); }
      if (self.ConfigData.snippedlogo == false) { setDefault.push(6); }
      const setDefaultJson = JSON.stringify(setDefault);
      const formData = new FormData()
      formData.append('LoginLogo', self.ConfigData.LoginLogo);
      formData.append('NavLogo', self.ConfigData.navlogo);
      formData.append('NavBG', self.ConfigData.navBG);
      formData.append('SubBG', self.ConfigData.subNavBG);
      formData.append('SnippedLogo', self.ConfigData.snippedlogo);
      formData.append('ChatbotName', self.ConfigData.ChatbotName);
      formData.append('ChatbotIcon', isImgChat == true ? "" : self.ConfigData.ChatbotIcon);
      formData.append('FontColorTitle', self.ConfigData.FontColorTitle.replace("#", ""));
      formData.append('chatColorTheme', self.ConfigData.chatColorTheme.replace("#", ""));
      formData.append('NavbarBtnColorTheme', self.ConfigData.NavbarBtnColorTheme.replace("#", ""));
      formData.append('NavbarTxtColorTheme', self.ConfigData.NavbarTxtColorTheme.replace("#", ""));
      formData.append('snippedchatColorTheme', self.ConfigData.snippedColorThemeChat.replace("#", ""));
      formData.append('FullstreamWelcomeTitle', self.fullstreamPreview.welcomeTitle);
      formData.append('FullstreamWelcomeSubtitle', self.fullstreamPreview.welcomeSubtitle);
      formData.append('FullstreamDisclaimerText', self.fullstreamPreview.disclaimerText);
      formData.append('FullstreamNavbarBtnColorTheme', self.ConfigData.FullstreamNavbarBtnColorTheme.replace("#", ""));
      formData.append('FullstreamNavbarTxtColorTheme', self.ConfigData.FullstreamNavbarTxtColorTheme.replace("#", ""));
      formData.append('FullstreamChatColorTheme', self.ConfigData.FullstreamChatColorTheme.replace("#", ""));
      formData.append('setDefaultJson', setDefaultJson);
      if (isImgChat == true) { formData.append('ChatIcon', self.ConfigData.ChatbotIcon ?? ""); }
      let data = {
        formData: formData,
      }
      self.$call.UploadTheme(data, (dataResponse) => {
        if (dataResponse.status == 0) {
          self.SuccessMessage = " Successfully Saved Theme !";
          self.showSuccess = true;
          clearTimeout(self._addToastTimer);
          self._addToastTimer = setTimeout(() => {
            self.showSuccess = false;
          }, 1500);
          self.GetStartUpImage;
          self.configColor;
          self.dialog = false;
          window.location.reload();
        }
      },
        (err) => {
          console.error(err)
          self.dialog = false;
        }
      )
    },
    handleFileImport() {
      this.$refs.uploader.click();
    },
  },
};
</script>
<style scoped>
.card {
  border-radius: 10px !important;
  height: auto;
  overflow: visible;
  margin: 0 0 2rem 0;
  padding: 0;
}

.pagin {
  margin-top: 1.5rem;
}

.flex {
  margin: 2rem;
  /* margin-right: 2rem; */
}

.img-intersection {
  width: 100%;
  height: 100%;
  max-width: 100%;
}

.tab-header-row {
  border-bottom: 2px solid #e0e0e0;
  margin-left: 1px !important;
  margin-right: 1px !important;
}

.sticky-header {
  position: sticky;
  top: 0px;
  z-index: 100;
  background-color: #ffffff;
}

.tab-buttons {
  display: flex !important;
  justify-content: start !important;
  gap: 19px !important;
  flex-wrap: nowrap !important;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 8px;
  scrollbar-width: thin;
  scrollbar-color: rgba(56, 89, 208, 0.35) transparent;
}

.tab-buttons::-webkit-scrollbar {
  height: 6px;
}

.tab-buttons::-webkit-scrollbar-track {
  background: transparent;
}

.tab-buttons::-webkit-scrollbar-thumb {
  background: rgba(56, 89, 208, 0.35);
  border-radius: 999px;
}

.tab-btn {
  border: 1px solid #3859D0;
  color: #3859D0;
  border-radius: 50px !important;
  text-transform: none !important;
  padding: 8px 24px !important;
  height: 45px;
  min-width: 100px;
  flex: 0 0 auto;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}
.tab-btn :deep(.v-btn__content) {
  font-weight: 600 !important;
  font-size: 16px !important;
}

.tab-btn__icon {
  display: block;
  transition: filter 0.2s ease;
}

.tab-btn:hover {
  background-color: #EFF4FF !important;
}

.tab-btn--active {
  color: #ffffff !important;
  border-color: transparent !important;
  background: linear-gradient(90deg, #3859D0 0%, #6B8CFF 100%) !important;
  box-shadow: 0 10px 20px rgba(56, 89, 208, 0.22) !important;
}

.tab-btn--active:hover {
  background: linear-gradient(90deg, #3150C1 0%, #5F80EF 100%) !important;
  transform: translateY(-1px);
}

.tab-btn--active .tab-btn__icon {
  filter: brightness(0) saturate(100%) invert(100%);
}

.tab-btn--active :deep(.v-icon),
.tab-btn--active :deep(.v-btn__content) {
  color: #ffffff !important;
}

.action-buttons {
  height: 45px;
  flex-shrink: 0;
}
.default-btn {
  border-radius: 50%;
  min-width: 45px !important;
  max-width: 45px !important;
  height: 45px;
}
.save-btn {
  border-radius: 16px;
  height: 45px;
  text-transform: none !important;
  font-size: 15px;
  padding: 0 24px !important;
}

.reset-btn{
  border-radius: 16px;
  height: 45px;
  padding: 0 20px !important;
  outline: auto;
  outline-color: #C9C9C9;
  box-shadow: none !important;
}
/* .reset-btn:hover {
  background-color: #EFF4FF !important;
} */

.chatbot-icon-selector {
  border: 1px solid rgba(56, 89, 208, 0.14);
  border-radius: 16px;
  padding: 14px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.chatbot-icon-selector__header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.chatbot-icon-selector__preview {
  width: 44px;
  height: 44px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.chatbot-icon-selector__image {
  width: 44px;
  height: 44px;
  border-radius: 999px;
}

.chatbot-icon-selector__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.chatbot-icon-selector__actions {
  margin-left: auto;
  flex-shrink: 0;
}

.chatbot-icon-selector__text label {
  color: #111827;
  font-size: 14px;
  font-weight: 700;
}

.chatbot-icon-selector__text span {
  color: #6b7280;
  font-size: 12px;
}

.chatbot-icon-selector__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(42px, 1fr));
  gap: 8px;
}

.chatbot-icon-option {
  height: 42px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 12px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

.chatbot-icon-option:hover,
.chatbot-icon-option--active {
  background: color-mix(in srgb, currentColor 10%, white);
  border-color: currentColor;
  transform: translateY(-1px);
}

.chatbot-icon-option--upload {
  margin: 0;
}

.style-div {
  /* border : 1px solid #949AA8 !important; */
  border-radius: 16px;
  background-color: #E1E1E132;
  padding: 12px 28px;
  height: 400px;
}

.fullstream-style-div {
  height: auto;
  min-height: 500px;
}

.fullstream-style-div--compact {
  min-height: 360px;
}

.fullstream-style-div--single {
  min-height: auto;
  height: auto;
}

.fullstream-control-group {
  margin-bottom: 20px;
}

.fullstream-control-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.fullstream-control-label {
  display: block;
  margin-bottom: 8px;
  color: #334155;
  font-size: 14px;
  font-weight: 600;
}

.fullstream-control-panel {
  padding: 16px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 18px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(248, 250, 252, 0.92) 100%);
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.05);
}

.fullstream-control-panel--last {
  margin-top: 20px;
}

.fullstream-mini-reset {
  min-width: 36px !important;
  max-width: 36px !important;
  width: 36px;
  height: 36px;
  padding: 0 !important;
}

/* Dialog Card Styles */
.dialog_div {
  background-color: #ffffff; 
  box-shadow: rgba(0, 0, 0, 0.11) 0px 4px 22px !important; 
  border-radius: 16px; 
  max-height: 500px; 
  min-height: 500px; 
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.fullstream-preview-card {
  background: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.11) 0px 4px 22px !important;
  border-radius: 16px;
  min-height: 500px;
}

.fullstream-section-preview {
  min-height: auto;
}

.fullstream-text-preview-card,
.fullstream-header-preview-shell,
.fullstream-chat-preview-shell {
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  background:
    radial-gradient(circle at top right, rgba(56, 89, 208, 0.08), transparent 28%),
    linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.fullstream-text-preview-card {
  min-height: 468px;
  padding: 40px 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  gap: 32px;
}

.fullstream-text-preview-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
}

.fullstream-text-preview-footer {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.fullstream-preview-kicker {
  display: inline-flex;
  align-self: center;
  margin-bottom: 20px;
  padding: 8px 14px;
  border-radius: 999px;
  background-color: rgba(56, 89, 208, 0.1);
  color: #3859d0;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.fullstream-preview-disclaimer-box {
  margin: 28px auto 0;
  max-width: 520px;
  padding: 16px 18px;

  color: #475569;
  font-size: 13px;
  line-height: 1.6;
}

.fullstream-preview-disclaimer-box--below-chat {
  width: 100%;
  max-width: none;
  margin: 0;
  text-align: center;
}

.fullstream-header-preview-shell {
  min-height: 248px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 18px;
}

.fullstream-header-preview-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.fullstream-header-preview-shell--compact {
  min-height: 0;
  padding: 18px;
}

.fullstream-header-preview-label {
  color: #475569;
  font-size: 13px;
  font-weight: 700;
}

.fullstream-header-preview-bar {
  min-height: 84px;
  border-radius: 22px;
  padding: 0 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.1);
}

.fullstream-header-preview-spacer {
  width: 24px;
  height: 24px;
}

.fullstream-header-preview-content {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
  min-width: 0;
}

.fullstream-header-preview-chip {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 999px;
  border: 1px solid currentColor;
  font-size: 12px;
  font-weight: 700;
}

.fullstream-header-preview-topic {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 600;
}

.fullstream-preview-helper-text {
  color: #64748b;
  font-size: 13px;
  line-height: 1.6;
}

.fullstream-chat-preview-shell {
  min-height: 320px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.fullstream-chat-preview-thread {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.fullstream-chat-preview-row {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}

.fullstream-chat-preview-row--user {
  justify-content: flex-end;
}

.fullstream-chat-preview-avatar {
  width: 38px;
  height: 38px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.fullstream-chat-preview-avatar-image {
  width: 38px;
  height: 38px;
  border-radius: 999px;
}

.fullstream-chat-preview-bubble {
  max-width: 72%;
  border-radius: 18px;
  padding: 12px 16px;
  font-size: 13px;
  line-height: 1.6;
}

.fullstream-chat-preview-bubble--bot {
  background-color: #ffffff;
  color: #334155;
  border: 1px solid rgba(148, 163, 184, 0.2);
}

.fullstream-chat-preview-bubble--user {
  color: #ffffff;
}

.fullstream-chat-preview-composer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 18px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  background-color: rgba(255, 255, 255, 0.94);
}

.fullstream-chat-preview-composer--text-preview {
  width: 100%;
}

.fullstream-chat-preview-placeholder {
  color: #94a3b8;
  font-size: 14px;
}

.fullstream-chat-preview-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.fullstream-chat-preview-send {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.12);
}

.fullstream-preview-shell {
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  min-height: 468px;
  background:
    radial-gradient(circle at top right, rgba(56, 89, 208, 0.08), transparent 28%),
    linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.fullstream-preview-topbar {
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.18);
  background-color: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(6px);
}

.fullstream-preview-topbar-spacer {
  width: 24px;
  height: 24px;
}

.fullstream-preview-model-wrap {
  margin-left: auto;
}

.fullstream-preview-model-label {
  color: #71717a;
  font-size: 13px;
  font-weight: 600;
}

.fullstream-preview-body {
  flex: 1;
  padding: 24px 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.fullstream-preview-message-row {
  display: flex;
  gap: 12px;
  align-items: flex-end;
}

.fullstream-preview-message-row--user {
  justify-content: flex-end;
}

.fullstream-preview-avatar {
  width: 36px;
  height: 36px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.fullstream-preview-message-bubble {
  max-width: 72%;
  border-radius: 18px;
  padding: 12px 16px;
  font-size: 13px;
  line-height: 1.5;
}

.fullstream-preview-message-bubble--bot {
  background-color: #ffffff;
  color: #334155;
  border: 1px solid rgba(148, 163, 184, 0.2);
}

.fullstream-preview-message-bubble--user {
  background-color: #e5e7eb;
  color: #3f3f46;
}

.fullstream-preview-welcome {
  padding: 18px 8px 8px;
  text-align: center;
}

.fullstream-preview-title {
  margin: 0;
  color: #111827;
  font-size: 32px;
  line-height: 1.15;
  font-weight: 700;
}

.fullstream-preview-subtitle {
  margin: 12px auto 0;
  max-width: 460px;
  color: #71717a;
  font-size: 15px;
  line-height: 1.6;
}

.fullstream-preview-shortcuts {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.fullstream-preview-shortcut-card {
  background-color: rgba(255, 255, 255, 0.82);
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 18px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #475569;
  font-size: 12px;
  min-height: 120px;
}

.fullstream-preview-shortcut-card strong {
  color: #0f172a;
  font-size: 14px;
}

.fullstream-preview-shortcut-icon {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.fullstream-preview-footer {
  padding: 16px 20px 20px;
}

.fullstream-preview-composer {
  border-radius: 20px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  background-color: rgba(255, 255, 255, 0.94);
  padding: 12px 14px;
  box-shadow: 0 16px 30px rgba(15, 23, 42, 0.06);
}

.fullstream-preview-input-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.fullstream-preview-icon-btn,
.fullstream-preview-send-btn {
  box-shadow: none !important;
}

.fullstream-preview-input {
  flex: 1;
  min-height: 42px;
  display: flex;
  align-items: center;
  padding: 0 14px;
  border-radius: 14px;
  background-color: #f8fafc;
  color: #94a3b8;
  font-size: 14px;
}

.fullstream-preview-meta {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.fullstream-preview-counter {
  color: #71717a;
  font-size: 10px;
  flex-shrink: 0;
}

.fullstream-preview-disclaimer {
  color: #71717a;
  font-size: 10px;
  line-height: 1.5;
}

@media (max-width: 1264px) {
  .fullstream-preview-shortcuts {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 960px) {
  .tab-header-row {
    row-gap: 12px;
  }

  .fullstream-preview-title {
    font-size: 26px;
  }

  .fullstream-header-preview-bar,
  .fullstream-chat-preview-composer {
    flex-direction: column;
    align-items: flex-start;
  }

  .fullstream-header-preview-content {
    width: 100%;
    margin-left: 0;
    flex-wrap: wrap;
  }

  .fullstream-preview-message-bubble {
    max-width: 100%;
  }

  .fullstream-chat-preview-bubble {
    max-width: 100%;
  }

  .fullstream-preview-meta {
    flex-direction: column;
  }
}

.success-toast {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(100deg, #2ABF56 0%, #135928 100%) !important;
  color: #ffffff;
  padding: 10px 24px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  z-index: 2100;
  width: 50%;
  max-width: 700px;
  min-width: 320px;
  justify-content: center;
  padding: 12px;
  border: 1px solid #ffffff;
  gap: 20px;
  margin-top: 140px;
}

.dialog-card {
  border-radius: 12px !important;
}
.cancel-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 16px !important;
  height: 44px;
  min-width: 120px;
  transition: all 0.2s ease;
  box-shadow: none !important;
  color: #646464 !important;
  border-radius: 16px !important;
  border: 1px solid var(--Border, #949AA8) !important;
}
.delete-confirm-btn{
  background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%);
}
.warning-btn{
  border-radius: 16px;
  background: var(--Active-red, #C30000);
  color: white;
  width: 100px;
}
</style>